// eslint-disable-next-line you-dont-need-lodash-underscore/throttle
import { throttle } from "lodash";

export default throttle;
